import React from 'react'
import { Link, useMatch, useResolvedPath } from 'react-router-dom'

const LinkCustom = ({ children, to, ...props }) => {
  let resolved = useResolvedPath(to)
  let match = useMatch({ path: resolved.pathname, end: true })
  return (
    <div>
      <Link style={{ color: match ? 'orange' : 'white' }} to={to} {...props}>
        {children}
      </Link>
    </div>
  )
}

export default LinkCustom